import { DeviceErrors } from "@minervaproject/avsubsystem-core";

export enum PreclassTestNameType {
  AUDIO_LEVEL = "audio_level",
  BROWSER = "browser",
  EXCEPTION = "exception",
  MIC_ACCESS_ALLOWED = "mic_access_allowed",
  CAMERA_ACCESS_ALLOWED = "camera_access_allowed",
  MIC_CAMERA_PREFERENCES = "mic_camera_preferences",
  ENUMERATE_DEVICES = "enumerate_devices",
  ACCESS_NOT_ALLOWED = "access_not_allowed",
  OTHER_APPS_USING_CAMERA = "other_apps_using_camera",
  CONNECTION = "connection",
  STREAM_PUBLISH = "stream_publish",
}

export enum PreclassCheckType {
  PRECLASS = "preclass",
  PRECLASS_OBSERVER = "preclass_observer",
  SYSTEM_CHECK = "system_check",
}

export enum PreclassTestCategoryType {
  SOFTWARE = "software",
  HARDWARE = "hardware",
  CONNECTION = "connection",
  MIC_AND_CAMERA = "mic_and_camera",
  UNEXPECTED = "unexpected",
}

export enum PreclassTestSpecificErrorsType {
  WRONG_BROWSER = "wrong_browser",
  OLD_BROWSER = "old_browser",

  AUDIO_LEVEL_NOT_DETECTED = "audio_level_not_detected",

  SLOW_NETWORK = "slow_network",

  AV_CONNECTION_FATAL = "av_connection_fatal",
  AV_CONNECTION_RETRYING = "av_connection_retrying",

  AV_PUBLISH_STREAM_FAILED = "av_publish_stream_failed",

  UNEXPECTED_EXCEPTION = "unexpected_exception",
}

export enum PreclassTestResultSeverityType {
  SKIPPABLE = "skippable",
  NONSKIPPABLE = "nonskippable",
}

export type PreclassTestResultMessageType = {
  alertKind: "info" | "error" | "success";
  severity?: PreclassTestResultSeverityType;
  message: string;
  action: string;
  link?: string;
};

export type PreclassCheckResultType = {
  [key in PreclassTestResultType["name"]]?: PreclassTestResultType;
};

export type TestRunOutcomeType = {
  haveAllTestsRun: boolean;
  hasAnyTestFailed: boolean;
  resultMessage: PreclassTestResultMessageType | null;
  testResults: PreclassCheckResultType;
};

export type PreclassTestErrorsType = PreclassTestSpecificErrorsType | DeviceErrors;

export enum PreclassTestOutcomeType {
  NA = "na",
  SUCCESS = "success",
  // I've added this for in progress messages that we can prioritize
  // in preclass_test_messages.ts
  IN_PROGRESS = "in_progress",
  FAIL = "fail",
  ABORT = "abort",
  EXCEPTION = "exception",
}

export type PreclassTestResultType = {
  name: PreclassTestNameType;
  category: PreclassTestCategoryType;
  outcome: PreclassTestOutcomeType;
  error?: PreclassTestErrorsType;
  message?: string;
  // A few tests have additional data that can be useful for investigation
  data?: {
    cpus?: number;
    memory?: number;
    message?: string;
    avState: string;
  };
};
